import { Pipe, PipeTransform } from '@angular/core';
import * as prettyBytes from 'pretty-bytes';

@Pipe({
  name: 'convertSize',
})
export class ConvertSizePipe implements PipeTransform {
  transform(bytes: number, decimals = 0): string {
    if (bytes <= 0) {
      return '0 b';
    }

    return prettyBytes(bytes);
  }
}
